export default __webpack_public_path__ + "static/media/Elec6.11842797.png";